import { Container } from 'pixi.js';

export function resetContainer(container: Container, removeChildren = false): Container {
  if (container.destroyed) return new Container();

  if (removeChildren) {
    container.removeChildren();
  }

  container.removeTweens(true);
  container.removeAllListeners();

  return container.props({
    parent: null,
    pivot: 0,
    alpha: 1,
    scale: 1,
    x: 0,
    y: 0,
    anchor: 0,
    tint: 0xffffff,
    eventMode: 'auto',
    visible: true,
    angle: 0,
    zIndex: 0,
  });
}
